export enum KeyInInformationStep {
  NextOfKinDetails = 0,
  ServiceRecipientDetails = 1
}

export enum RelationshipToClient {
  Spouse = 'Spouse',
  Child = 'Child',
  Brother = 'Brother',
  DaughterInLaw = 'Daughter-in-law',
  Neighbour = 'Neighbour',
  Parent = 'Parent',
  Others = 'Others'
}

// Despite the name, this covers both the NOK flow's service-recipient (B3 client) details AND the
// SELF flow's own personal details (SelfDetailsForm / ConfirmDetailsMySelf) - same field set either way.
export interface ServiceRecipientFormValues {
  fullName: string;
  dateOfBirth: string;
  gender: string;
  nric: string;
  email: string;
  homeNo?: string;
  mobileNo: string;
  maritalStatus?: string;
  residentialStatus?: string;
  nationality?: string;
  languagesSpoken: string[];
  otherLanguage?: string;
  isNtucMember: boolean;
  ntucMemberNo?: string;
}

export interface NextOfKinFormValues {
  name: string;
  email: string;
  homeNo?: string;
  mobileNo: string;
  relationshipToClient: string;
  relationshipOthers?: string;
  isDecisionMaker: boolean;
}
